import Vue from 'vue'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
 
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';

 
Vue.use(Cropper)

export default Cropper